<div class="container">
<h1 class="mb-2">We Answer Your Calls,<br/> 
    On Your Behalf,<br/> 
    In Your Company Name</h1>
<h2 class="lead my-3 my-md-5">24 hours a day, 7 days a week</h2>
<button (click)="scrollToNumberChooser()" class="btn btn-primary mt-3 mt-md-0">Choose Your Number</button>
</div>